var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForms = function SvgForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M6 28a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V30a2 2 0 0 0-2-2zm10.567 5.332a1 1 0 1 0-1.414-1.415l-4.95 4.95-2.338-2.339a1 1 0 0 0-1.414 1.414l3.045 3.046a1 1 0 0 0 1.415 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M7 10v9h9v-9zM6 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM7 52v9h9v-9zm-1-3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V51a2 2 0 0 0-2-2zM27 9a2 2 0 0 0-2 2v6.81a2 2 0 0 0 2 2h37a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2zm3 3.905a1.5 1.5 0 0 0 0 3h30.6a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M27 30a2 2 0 0 0-2 2v6.81a2 2 0 0 0 2 2h37a2 2 0 0 0 2-2V32a2 2 0 0 0-2-2zm3 3.905a1.5 1.5 0 0 0 0 3h30.6a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M27 51a2 2 0 0 0-2 2v6.81a2 2 0 0 0 2 2h37a2 2 0 0 0 2-2V53a2 2 0 0 0-2-2zm3 3.905a1.5 1.5 0 0 0 0 3h30.6a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })));
};
export default SvgForms;